import { createContext } from "react"

const WidgetResourcesInHourContext = createContext();

export default WidgetResourcesInHourContext;